<template>
    <div class="full-wrapper">
        <embed width="100%" height="100%" :src="'/static/file/'+pdfSrc" type="application/pdf">
    </div>

</template>
<style scoped>
    .full-wrapper{
        position: absolute;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
</style>
<script>
    export default {
        data(){
            return {
                props:'',
            };
        },
        props:{
            pdfSrc:{
                type: String
            },
        },
        created(){
            this.pdfSrc=this.$route.query.src;
        },
        mounted(){

        },
        watch: {

        },
        methods: {

        }
    };
</script>
